'use strict';
import React, { Component } from 'react';

class TableRowLink extends Component {

    constructor(props) {
        super(props);
        this.state = {
            routeToEditarConfiguracionProceso: props.routeToEditarConfiguracionProceso
        };
    } 


    render() {
        return (
            <div>             
                    <div key={"checkProdItem" + this.props.Id} className="row">
                        <div key={"checkProdItemCol" + this.props.Id} className="col-xs-12">
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2">
                                    <label className="tableroPointer with-hover"  id={"proceso" + this.props.Id} >{this.props.nombre} </label>
                                </li>
                            </ul>
                        </div>
                    </div>                
            </div>
        );
    }
}

export default TableRowLink